import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Field, TextInput } from './FormFields';

export const emptyAttendee = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  additionalInfo: '',
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Validates the attendee details (the calendar "Enter Details" form).
export const validateAttendee = (a = {}) => {
  const errors = {};
  if (!a.firstName || !a.firstName.trim()) errors.firstName = 'First name is required.';
  if (!a.lastName || !a.lastName.trim()) errors.lastName = 'Last name is required.';
  if (!a.phone || !String(a.phone).trim()) errors.phone = 'Phone number is required.';
  if (!a.email || !a.email.trim()) errors.email = 'Email is required.';
  else if (!EMAIL_RE.test(a.email)) errors.email = 'Enter a valid email address.';
  return errors;
};

// "Enter Details" form that appears after a time slot is selected, mirroring the
// GHL booking widget's fields.
const AttendeeDetails = ({ value = emptyAttendee, onChange, errors = {} }) => {
  const set = (key, v) => onChange({ ...value, [key]: v });

  return (
    <div className="preob-cal__details">
      <h3 className="preob-cal__details-title">Enter Details</h3>

      <div className="preob-grid preob-grid--2">
        <Field label="First Name" required htmlFor="att-first" error={errors.firstName}>
          <TextInput id="att-first" value={value.firstName} onChange={(v) => set('firstName', v)} placeholder="First name" required invalid={!!errors.firstName} />
        </Field>
        <Field label="Last Name" required htmlFor="att-last" error={errors.lastName}>
          <TextInput id="att-last" value={value.lastName} onChange={(v) => set('lastName', v)} placeholder="Last name" required invalid={!!errors.lastName} />
        </Field>

        <Field label="Phone" required htmlFor="att-phone" error={errors.phone}>
          <div className={`preob-phone${errors.phone ? ' preob-phone--invalid' : ''}`}>
            <PhoneInput
              id="att-phone"
              defaultCountry="US"
              international
              limitMaxLength
              placeholder="(000) 000-0000"
              value={value.phone}
              onChange={(v) => set('phone', v || '')}
            />
          </div>
        </Field>
        <Field label="Email" required htmlFor="att-email" error={errors.email}>
          <TextInput id="att-email" type="email" value={value.email} onChange={(v) => set('email', v)} placeholder="name@email.com" inputMode="email" required invalid={!!errors.email} />
        </Field>
      </div>

      <Field label="Additional Information" htmlFor="att-info">
        <textarea
          id="att-info"
          className="preob-input preob-textarea"
          rows={3}
          value={value.additionalInfo}
          onChange={(e) => set('additionalInfo', e.target.value)}
          placeholder="Is there anything you would like us to know before your appointment?"
        />
      </Field>
    </div>
  );
};

export default AttendeeDetails;
